export default __webpack_public_path__ + "static/media/GF_ANDY_FURY.49216fd3.jpg";